import * as React from 'react'
import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { OrgHealthcheckDataGrid } from './OrgHealthcheckDataGrid'

type OrgHealthcheckProps = {
  org: OrganizationDetailFragment
}

export const OrgHealthcheck = ({ org }: OrgHealthcheckProps) => {
  if (!org) return null
  return <OrgHealthcheckDataGrid org={org} />
}
